/** Namespace `cost` — HQ-2026-018 « Chi phí hạ tầng ». Bản gốc tiếng Việt. */
export const cost = {
  title: "Chi phí hạ tầng",
  subtitle:
    "Neon (CU-giờ compute) và GCP (tiền trên billing export), chụp mỗi ngày một lần. Mỗi số kèm nguồn, mốc dữ liệu và chất lượng; không có nguồn thì không hiện số.",
  loadFailed: "Không đọc được số chi phí.",
  generatedAt: "Tính lúc {time}",

  "section.sources": "Nguồn dữ liệu",
  "section.apps": "Theo app",
  "section.appsHint": "Ngày đã chốt gần nhất (đủ 24 giờ + độ trễ nguồn), tuần này so tuần trước, run-rate 30 ngày = trung bình 7 ngày × 30.",
  "section.topDelta": "Tăng nhiều nhất",
  "section.topDeltaHint": "Tài nguyên tăng nhiều nhất so với trung vị 7 ngày đã chốt trước đó.",
  "section.unattributed": "Chưa quy được app",
  "section.unattributedHint": "Tài nguyên có chi phí mà hub chưa biết thuộc app nào — phải về 0 hoặc vào nhóm có chủ.",

  "provider.neon": "Neon",
  "provider.gcp": "GCP",
  "source.neon.consumption_v2": "Neon consumption API v2 (theo giờ, cộng theo ngày VN)",
  "source.gcp.billing_export": "BigQuery billing export (bảng chi tiết)",

  "status.ok": "Đã thu",
  "status.empty": "Đã thu · nguồn chưa có dòng nào",
  "status.failed": "Thu hỏng",
  "status.forbidden": "Bị từ chối quyền",
  "status.not_configured": "Chưa cấu hình",
  "status.never": "Worker chưa thu lần nào",

  "quality.measured": "đo",
  "quality.derived": "suy ra",
  "quality.estimated": "ước tính",
  "quality.unknown": "không rõ",

  "unit.cu_hours": "CU-giờ",

  "col.source": "Nguồn",
  "col.status": "Trạng thái",
  "col.lastAttempt": "Thu lần cuối",
  "col.lastSuccess": "Thành công lần cuối",
  "col.settled": "Ngày chốt gần nhất",
  "col.error": "Mã lỗi",
  "col.app": "App",
  "col.provider": "Nguồn",
  "col.latest": "Ngày chốt",
  "col.thisWeek": "7 ngày này",
  "col.lastWeek": "7 ngày trước",
  "col.wow": "So tuần trước",
  "col.runRate": "Run-rate 30 ngày",
  "col.resource": "Tài nguyên",
  "col.baseline": "Trung vị 7 ngày",
  "col.delta": "Chênh",

  "bucket.unattributed": "chưa quy được",
  "bucket.shared": "dùng chung",
  emptyApps: "Chưa có ngày nào đã chốt — chưa có số để so.",
  emptyTopDelta: "Không tài nguyên nào tăng so với trung vị 7 ngày (hoặc chưa đủ 4 ngày baseline).",
  emptyUnattributed: "Không có — mọi chi phí đã quy được về app.",
  asOf: "Dữ liệu tới {time}",
  noValue: "—",
} as const;
